<!--
 * File: App.vue
 * Project: timo
 * File Created: Monday, 21st September 2020 5:35:19 pm
 * Author: Timo Zacherl
 * License: MPL-2.0
 * 
 * -----
 * Last Modified: Monday, 21st September 2020 8:59:20 pm
 * Modified By: Timo Zacherl
 * -----
 * 
 * Copyright © 2020 Timo Zacherl. All rights reserved.
-->

<template>
  <div id="app">
    <Navbar />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default {
  components: {
    Navbar,
    Footer
  }
};
</script>

<style lang="scss">
@import "@/scss/app.scss";

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  min-height: 100vh;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
